/**
 * The one share image, and the one app icon.
 *
 * src/app/opengraph-image.tsx is the generator and the only source of truth for the share card.
 * The static public/brand/og-image.png and public/brand/logo.png carried the PRE-REBRAND art -
 * the teal mark and the retired "Neurodivergent-Led Innovation" line - and AXAI-BRAND-001 §8 says
 * there is no teal in the brand. Nothing points at those files any more.
 *
 * The trap this exists to close: a page that sets its own `openGraph` block REPLACES the inherited
 * file-convention image rather than merging with it, so every such block must carry OG_IMAGE or
 * the page ships with no share image at all. That is how 33 pages, including every insights
 * article, came to have none, and why the preview on LinkedIn fell back to the old art
 * (AXAI-SEO-001, 21 Oct 2026).
 */

export const OG_IMAGE_PATH = '/opengraph-image';

export const OG_IMAGE = {
  url: OG_IMAGE_PATH,
  width: 1200,
  height: 630,
  alt: 'aXai — New ideas. A different way of working.',
} as const;

/**
 * The 512px mark (AXAI-BRAND-001 §4), as a static file regenerated from src/lib/brand/mark.ts.
 *
 * NOT a generated route. "icon-512" and "icon-192" are not Next metadata-file conventions - only
 * `icon`, `icon<n>`, `apple-icon` and `opengraph-image` are - so src/app/icon-192.tsx never
 * shipped and /icon-192 has always been a 404. A first attempt at this fix added icon-512.tsx
 * beside it and put /icon-512 in the manifest and the schema, which pointed both at a 404 for one
 * deploy (21 Oct 2026). The static PNG is served, and is checked by the test.
 */
export const ICON_512_PATH = '/icon-512.png';
